// extracted by mini-css-extract-plugin
export default {"resultGroup":"result-group_resultGroup__-PNGv","activeResultGroup":"result-group_activeResultGroup__TFERg"};